import { type PlanId } from '@/lib/branchTypes'
import { type PerspectiveCategory } from '@/app/common/blocks/perspectiveTabContext'
import {
  PLAN_TOOLTIP,
  TIMELINE_SPINE_LABEL,
  TIMELINE_SPINE_PLAN,
} from '../planATimelineDiagramModel'
import { type TimelinePlacement } from '../timelineDiagramLayout'
import { type DiagramNavigate } from '../useTimelineDiagramNavigation'
import { type SelectedEnding } from '../useSelectedEnding'
import { DiagramLabel } from './DiagramLabel'

// Plan A (the spine) plus the alternate plans (S/B/C/D), all sharing one centered
// left-hand column so the labels line up vertically and sit *on* their own arm.
// Positions come from PLACEMENT. Plan A carries the bold/large `emphasis` — but
// only while the main scenario itself is what's active; the moment the reader
// opens an ending (Epilogue / Public / Insider, in place or as a standalone POV
// page) that emphasis moves to the open ending's label (see EndpointLabels), so
// the diagram always highlights exactly what's being read. The two "an ending is
// active" signals match EndpointLabels: `selectedEnding` (live hash) for in-place
// expansion, `selected` (page-level `?perspective=`) for a standalone POV page.
export const PlanLabels = ({
  placement,
  currentPlan,
  selected,
  selectedEnding,
  onNavigate,
}: {
  placement: TimelinePlacement
  currentPlan: PlanId | null
  selected: PerspectiveCategory
  selectedEnding: SelectedEnding | null
  onNavigate: DiagramNavigate
}) => (
  <>
    <DiagramLabel
      x={placement.spine.planLabelAt.x}
      y={placement.spine.planLabelAt.y}
      anchor="center"
      overlay
      emphasis={selectedEnding === null && selected === 'mainScenario'}
      tooltip={PLAN_TOOLTIP[TIMELINE_SPINE_PLAN]}
      onClick={() => onNavigate(TIMELINE_SPINE_PLAN)}
    >
      {TIMELINE_SPINE_LABEL}
    </DiagramLabel>

    {placement.forkPlans.map(plan => (
      <DiagramLabel
        key={plan.planId}
        x={plan.labelAt.x}
        y={plan.labelAt.y}
        anchor="center"
        overlay
        active={currentPlan === plan.planId}
        tooltip={PLAN_TOOLTIP[plan.planId]}
        onClick={() => onNavigate(plan.planId)}
      >
        {plan.label}
      </DiagramLabel>
    ))}
  </>
)
